<template>
  <v-container class="text-center">
    <h1>Активная лицензия системы не допускает использование данного справочника</h1>
    <h2>По вопросам приобретения компонентов системы, обратитесь, пожалуйста, к разработчику</h2>
  </v-container>
</template>

<script>
export default {
  name: 'notFoundRef'
}
</script>

<style scoped>

</style>
